import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BackButton from "../../components/BackButton";
import TitleRecordFunction from "../../components/TitleRecordFunction";
import api from '../../api/manage_database/SensorReq';
import { useLocation } from "react-router-dom";
import { toast } from 'sonner';
import { FaSave } from "react-icons/fa";
import Spinner from "../../components/Spinner";
import SelectSensorType from "../../components/SelectSensorType";
import InputDimension from "../../components/InputDimension";
import InputSerialNumber from "../../components/InputSerialNumber";
import handleChange from "../../utils/handleChange";

const SensorRecord = () => {

    const location = useLocation();

    const addRecordMessage = location.state?.addRecordMessage;
    const deleteRecordMessage = location.state?.deleteRecordMessage;
    
    const isViewRecord = location.state?.anotherTypeOfPage === undefined;

    const { sensor_id } = useParams();

    const deletedSensor = location.state?.data;

    const [editState, setEditState] = useState(false);

    const [sensorTypes, setSensorTypes] = useState([]);
    const [type, setType] = useState('');
    const [selectedSensorType, setSelectedSensorType] = useState('');
    const [dimension, setDimension] = useState('');
    const [serialNumber, setSerialNumber] = useState('');

    const [updatingRecordState, setUpdatingRecordState] = useState(false);

    const handleEditButton = () => {
        setEditState(prev => !prev);
    }

    const handleSaveButton = async () => {
        setUpdatingRecordState(true);
        const toastId = toast('');
        toast.loading('Updating Sensor record...', {id: toastId});
        try {
            const response = await api.put(
                '/record',
                {
                    id: sensor_id,
                    dimension: dimension,
                    serial_number: serialNumber,
                    type: selectedSensorType
                },
                {
                    withCredentials: true
                }
            );
            if (response.data.success) {
                toast.success(response.data.message, {id: toastId});
                setType(response.data.payload[0].type);
                setSelectedSensorType(response.data.payload[0].type);
                setDimension(response.data.payload[0].dimension);
                setSerialNumber(response.data.payload[0].serial_number);
            } else {
                toast.error(response.data.message, {id: toastId});
            }
        } catch (err) {
            console.log(err.response);
        }
        setEditState(prev => !prev);
        setUpdatingRecordState(false);
    }

    useEffect(() => {
        const fetchSensorTypes = async () => {
            try {
                const response = await api.get('types', {withCredentials: true});
                if (response.data.success) {
                    setSensorTypes(response.data.payload.types);
                } else {
                    toast.error('Not got data from database');
                }
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchSensorTypes();
    }, []);

    useEffect(() => {
        const getSensorDescriptionData = async() => {
            let attempts = 0
            while (attempts < 5) {
                try {
                    const response = await api.get(`record/${sensor_id}`, {withCredentials: true});
                    if (response.data.success) {
                        setType(response.data.payload[0].type);
                        setSelectedSensorType(response.data.payload[0].type);
                        setDimension(response.data.payload[0].dimension);
                        setSerialNumber(response.data.payload[0].serial_number);
                        return
                    } else {
                        toast.warning('Not got data from database! trying again...');
                    }
                    
                } catch (err) {
                    console.log(err.response);
                }
                
                attempts++;
                if (attempts < 5) {
                    await new Promise((res) => setTimeout(res, 2000));
                }
            }

            toast.error(`Data is not received after ${attempts} requests!`);
        };
        if (deletedSensor === undefined) {
            getSensorDescriptionData();
        } else {
            setType(deletedSensor.type);
            setDimension(deletedSensor.dimension);
            setSerialNumber(deletedSensor.serial_number);
        }
    }, []);
    
    return (
        <div className='sensor-record-container'>
            <div className="sensor-record-title-wrapper">
                <TitleRecordFunction
                    addRecordMessage={addRecordMessage}
                    deleteRecordMessage={deleteRecordMessage}
                    title='Sensor'
                    isViewRecord={isViewRecord}
                />
                {deletedSensor === undefined ? 
                    !editState ?
                        <button
                            className='sensor-record-edit-button'
                            onClick={handleEditButton}
                        >   Edit
                        </button> :
                        <button
                            className='sensor-record-save-button'
                            onClick={handleSaveButton}
                        >   Save &nbsp; <FaSave />
                        </button>
                : null}
            </div>
            {updatingRecordState ? <Spinner /> :
                <table className='sensor-record-table-style'>
                    {
                    editState ?
                        <tbody>
                            <tr>
                                <td>ID:</td>
                                <td>{sensor_id}<br /></td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>
                                    <SelectSensorType
                                        SensorTypes={sensorTypes}
                                        selectedSensorType={selectedSensorType}
                                        setSelectedSensorType={setSelectedSensorType}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>Dimension:</td>
                                <td>
                                    <InputDimension
                                        dimension={dimension}
                                        handleInputDimension={handleChange(setDimension)}
                                        classNameStyle='sensor-new-input'
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>Serial Number:</td>
                                <td>
                                    <InputSerialNumber
                                        serialNumber={serialNumber}
                                        handleInputSerialNumber={handleChange(setSerialNumber)}
                                        classNameStyle='sensor-new-input'
                                    />
                                </td>
                            </tr>
                        </tbody> :
                        <tbody>
                            <tr>
                                <td>ID:</td>
                                <td>{sensor_id}<br /></td>
                            </tr>
                            <tr>
                                <td>Type:</td>
                                <td>{type}<br /></td>
                            </tr>
                            <tr>
                                <td>Dimension:</td>
                                <td>{dimension}<br /></td>
                            </tr>                            
                            <tr>
                                <td>Serial Number:</td>
                                <td>{serialNumber}<br /></td>
                            </tr>                            
                        </tbody>}     
                </table>}
            <BackButton
                navigateTo='/manage-database'
            />
        </div>
    )
}

export default SensorRecord;